import * as Yup from 'yup';
import {
  STRING_FIELD_FULL_NAME_REQUIRED,
} from '@zr/components/Fields/labels';

export const FirstNameLastNameValidation = Yup.string().trim().required(STRING_FIELD_FULL_NAME_REQUIRED)
// require at least 2 separate substrings separated by whitespace, where each substring is
// at least 2 characters
  .matches(/(\S{2,})(\s+)(\S{2,})/, STRING_FIELD_FULL_NAME_REQUIRED);
